"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var button_1 = require("ayvri-ui/lib/button");
var React = require("react");
var react_1 = require("react");
var user_geo_1 = require("../user-geo");
// tslint:disable-next-line:no-var-requires
var styles = require('./style.css');
exports.API = function (props) {
    var staticSrcPath = props.staticSrcPath, pricing = props.pricing;
    var _a = react_1.useState(props.currency), currency = _a[0], setCurrency = _a[1];
    var plan = (pricing || []).find(function (p) { return p.currency === currency; });
    var fetchCurrency = function () { return __awaiter(_this, void 0, void 0, function () {
        var newCurrency;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, user_geo_1.userGeo().getCurrency()];
                case 1:
                    newCurrency = _a.sent();
                    setCurrency(newCurrency);
                    return [2 /*return*/];
            }
        });
    }); };
    react_1.useEffect(function () {
        fetchCurrency();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.hero, style: { backgroundImage: "url('" + staticSrcPath + "/assets/images/backgrounds/api_hero.png')" } },
            React.createElement("div", { style: { padding: '5%' } },
                React.createElement("h2", null, "3D Maps for your Apps"),
                React.createElement("h3", null, "Get the most from your data and content while keeping your users engaged and coming back for more."))),
        React.createElement("div", { className: styles.steps + ' ' + styles.inner },
            React.createElement("div", { className: styles.set },
                React.createElement("img", { style: { height: '5.5rem' }, src: staticSrcPath + "/assets/images/illustrations/map_pin.svg" }),
                React.createElement("h3", null, "Outdoor Discovery"),
                React.createElement("p", { style: { textAlign: 'center' } }, "Unlock the stories from your geodata")),
            React.createElement("div", { className: styles.set },
                React.createElement("img", { style: { height: '5.5rem' }, src: staticSrcPath + "/assets/images/illustrations/integrate.svg" }),
                React.createElement("h3", null, "Connect"),
                React.createElement("p", { style: { textAlign: 'center' } }, "Increase value for your users")),
            React.createElement("div", { className: styles.set },
                React.createElement("img", { style: { height: '5.5rem' }, src: staticSrcPath + "/assets/images/illustrations/real_time.svg" }),
                React.createElement("h3", null, "Real Time"),
                React.createElement("p", { style: { textAlign: 'center' } }, "Display the action as it unfolds"))),
        React.createElement("div", { className: styles.ourCustomersBenefits, style: { backgroundImage: "url('" + staticSrcPath + "/assets/images/backgrounds/topo-background.png')" } },
            React.createElement("div", { className: styles.inner, style: { textAlign: 'center' } },
                React.createElement("h1", null,
                    React.createElement("a", { href: '/api' }, "Become a Partner")),
                React.createElement("h2", null, "We work with exceptional apps to drive value and engagement"),
                React.createElement("div", { className: styles.partners },
                    React.createElement("img", { className: styles.partnerLogo, style: { filter: 'invert(0.3) grayscale(100%)' }, src: staticSrcPath + "/assets/images/logos/partners/viewranger.png" }),
                    React.createElement("img", { className: styles.partnerLogo, src: staticSrcPath + "/assets/images/logos/partners/dronelogbook.png" }),
                    React.createElement("img", { className: styles.partnerLogo, style: { filter: 'invert(0.5) grayscale(100%)' }, src: staticSrcPath + "/assets/images/logos/partners/mountainhub.png" })),
                React.createElement("div", { className: styles.partners },
                    React.createElement("img", { className: styles.partnerLogo, style: { filter: 'invert(0.3) grayscale(100%)' }, src: staticSrcPath + "/assets/images/logos/partners/rideCommand.png" }),
                    React.createElement("img", { className: styles.partnerLogo, src: staticSrcPath + "/assets/images/logos/partners/indian-motorcycle.png" }),
                    React.createElement("img", { className: styles.partnerLogo, style: { filter: 'invert(0.5) grayscale(100%)' }, src: staticSrcPath + "/assets/images/logos/partners/slingshot.png" })))),
        React.createElement("div", { className: styles.marketingBlocks },
            React.createElement("div", { className: styles.apiDescription },
                React.createElement("h1", null, "Connect"),
                React.createElement("h2", null, "Create scenes for Ayvri users"),
                React.createElement("ul", null,
                    React.createElement("li", null, "Free"),
                    React.createElement("li", { className: styles.strike }, "Include Your Branding"),
                    React.createElement("li", { className: styles.strike }, "Embed In Your App"),
                    React.createElement("li", { className: styles.strike }, "Include Photos"),
                    React.createElement("li", { className: styles.strike }, "Multi-track Scene")),
                React.createElement(button_1.Button, { type: 'primary', size: 'small', href: '/oauth2' }, "Connect Your Users")),
            React.createElement("div", { className: styles.apiDescription },
                React.createElement("h1", null, "Commercial"),
                React.createElement("h2", null, "Create 3D maps for your site or app"),
                React.createElement("ul", null,
                    React.createElement("li", null, "Usage Based Billing"),
                    plan ? (React.createElement("li", null,
                        plan.currency === 'EUR' ? plan.price + "\u20AC" : "$" + plan.price.toFixed(2) + " USD",
                        " /",
                        ' ',
                        plan.plays.toLocaleString(),
                        " plays / month")) : (''),
                    React.createElement("li", null, "Include Your Branding"),
                    React.createElement("li", null, "Embed In Your App"),
                    React.createElement("li", null, "Include Photos"),
                    React.createElement("li", null, "Multi-Track")),
                React.createElement(button_1.Button, { type: 'primary', size: 'small', href: '/api' }, "Get Ayvri For Your App"))),
        React.createElement("div", { className: styles.more + " " + styles.secondaryBlock },
            React.createElement("div", { className: styles.inner, style: { textAlign: 'center' } },
                React.createElement("h1", null, "Want to know more?"),
                React.createElement("h2", null,
                    "Check out the",
                    ' ',
                    React.createElement("a", { className: styles.brand_link, href: 'https://docs.ayvri.com' }, "API documentation"))))));
};
